import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import _merge from 'lodash-es/merge';

import { dropRemovedUploadEntries } from './slice';
import type { MetadataUpdate, UploaderMetadataAppState } from './types';

const initialState: UploaderMetadataAppState = {};

type AddMetadataPayload = { stateId: string; metadata: MetadataUpdate };

export const uploaderMetadataSlice = createSlice({
  name: 'uploader_metadata',
  initialState,
  reducers: {
    uploaderAddMetadata: (state, action: PayloadAction<AddMetadataPayload>) => {
      const { stateId, metadata } = action.payload;
      _merge(state, { [stateId]: metadata });
    },
  },
  extraReducers: dropRemovedUploadEntries,
});

export const { uploaderAddMetadata } = uploaderMetadataSlice.actions;

export const uploaderMetadataReducer = uploaderMetadataSlice.reducer;
